<script lang="ts" setup>
import Page from './Page.vue'
import LayoutEnum from '~/enums/LayoutEnum'

defineProps<{
  disableQuoteBar?: boolean
}>()
</script>

<template>
  <div>
    <Page :is-full-width="true">
      <template #header>
        <div>
          <LayoutHeader :type="LayoutEnum.Quote" />
        </div>
      </template>
      <slot />
    </Page>
  </div>
</template>
